import { render, staticRenderFns } from "./ModalCostumersTOperador.vue?vue&type=template&id=33a60df1&scoped=true"
import script from "./ModalCostumersTOperador.vue?vue&type=script&lang=js"
export * from "./ModalCostumersTOperador.vue?vue&type=script&lang=js"
import style0 from "./ModalCostumersTOperador.vue?vue&type=style&index=0&id=33a60df1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a60df1",
  null
  
)

export default component.exports